import React from 'react';
import { Link } from 'react-router-dom';

// Dismissible banner for open new-client requests. Mirrors CollectionBanner, with a
// distinct accent so the two aren't confused. `onDismiss(request)` clears one row.
export default function NewClientRequestBanner({ requests, onDismiss }) {
  if (!requests || requests.length === 0) return null;

  const fmtName = (name) => {
    if (!name) return 'A client';
    if (name.includes(',')) {
      const [last, first] = name.split(',').map((s) => s.trim());
      return `${first} ${last}`.trim();
    }
    return name;
  };
  const fmtWhen = (dt) => {
    if (!dt) return '';
    const d = new Date(dt);
    return isNaN(d) ? '' : d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  };

  return (
    <div style={{ marginBottom: 20 }}>
      {requests.map((r) => (
        <div
          key={r.acuityId}
          style={{
            display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap',
            background: 'linear-gradient(135deg, #6D28D9 0%, #9333EA 100%)',
            color: '#fff', borderRadius: 14, padding: '14px 20px', marginBottom: 10,
            boxShadow: '0 6px 20px rgba(109,40,217,0.22)',
          }}
        >
          <div style={{ flex: 1, minWidth: 220, fontSize: 15, fontWeight: 600 }}>
            🗂️ New client request: <strong>{fmtName(r.clientName)}</strong>
            {r.therapistName ? ` → ${r.therapistName}` : ''}
            {fmtWhen(r.apptDatetime) ? <span style={{ opacity: 0.85, fontWeight: 500 }}> · {fmtWhen(r.apptDatetime)}</span> : null}
          </div>
          <Link
            to="/admin/new-client-requests"
            style={{
              background: 'rgba(255,255,255,0.16)', color: '#fff', textDecoration: 'none',
              border: '1px solid rgba(255,255,255,0.55)', borderRadius: 8,
              padding: '8px 14px', fontWeight: 600, fontSize: 14, whiteSpace: 'nowrap',
            }}
          >
            Review
          </Link>
          <button
            onClick={() => onDismiss(r)}
            style={{
              background: 'transparent', color: 'rgba(255,255,255,0.9)',
              border: '1px solid rgba(255,255,255,0.55)', borderRadius: 8,
              padding: '8px 14px', fontWeight: 600, fontSize: 14, cursor: 'pointer', whiteSpace: 'nowrap',
            }}
          >
            Dismiss
          </button>
        </div>
      ))}
    </div>
  );
}
